import { createSvgIcon } from '../../createSvgIcon';

export const RatingIcon = createSvgIcon(
  <path
    d="M9.00561 13.6161L4.06109 16.2157L5.00561 10.7096L1 6.81054L6.52774 6.00941L9 1L11.4723 6.00941L17 6.81054L12.9944 10.7096L13.9389 16.2157L9.00561 13.6161Z"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  { displayName: 'RatingIcon', viewBox: '0 0 18 18' }
);
